module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aleg7-103e4fa36506fc35864704d668c85475.jpg";